export class ListingCache{
    userId?:string|null = null;
    url?:string|null = null;
    settings?:string|null = null;
    modelName?:string|null = null;
    viewId?:string|null = null;
    viewType?:string|null = null;
}